import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02f9fea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-100"
}
const _hoisted_2 = {
  key: 1,
  id: "container-user-upload",
  class: "d-flex flex-column align-items-center"
}
const _hoisted_3 = { class: "monogram" }
const _hoisted_4 = { class: "flex-grow-1 w-100" }
const _hoisted_5 = { class: "d-flex flex-column w-100" }

import {ref} from "vue";
import {useDefaultAPI} from "@/composables/api";
import theme from "@/theme";

import FileInputCapture from "@/components/FileInputCapture.vue"
import FileInputUpload from "@/components/FileInputUpload.vue";
import UploadConfirmation from "@/components/UploadConfirmation.vue";
import UploadStatus from "@/components/UploadStatus.vue";
import useTriggerEarliestAfter from "@/composables/delayedTrigger";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const triggerEarliestAfter = useTriggerEarliestAfter()
const api = useDefaultAPI()

const files = ref<File[]>([])

const status = ref<number>(-1)

const resetState = () => {
  setTimeout(() => {
    status.value = -1
    files.value = []
  }, 30000)
}

const triggerFileUpload = () => {
  const started = new Date().getTime()
  status.value = 0
  api.uploadImages(files.value)
      .then(() => {
        triggerEarliestAfter(started, 1000, () => {
          status.value = 1
          resetState()
        })
      })
      .catch((e) => {
        console.log(`Error occurred during upload: ${e}`)
        triggerEarliestAfter(started, 1000, () => {
          status.value = 2
          resetState()
        })
      })
}


return (_ctx: any,_cache: any) => {
  return (files.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (status.value < 0)
          ? (_openBlock(), _createBlock(UploadConfirmation, {
              key: 0,
              files: files.value,
              onUserDiscarded: _cache[0] || (_cache[0] = ($event: any) => (files.value=[])),
              onUserConfirmed: triggerFileUpload
            }, null, 8, ["files"]))
          : _createCommentVNode("", true),
        _createVNode(UploadStatus, { status: status.value }, null, 8, ["status"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(theme).monogram) + " ", 1),
          _createElementVNode("small", null, _toDisplayString(_unref(theme).date), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(theme).headline, (line) => {
            return (_openBlock(), _createElementBlock("h1", { key: line }, _toDisplayString(line), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(FileInputCapture, {
            onFilesSelected: _cache[1] || (_cache[1] = (fl) => files.value = fl),
            style: {"margin-bottom":"1rem"}
          }),
          _createVNode(FileInputUpload, {
            onFilesSelected: _cache[2] || (_cache[2] = (fl) => files.value = fl)
          })
        ])
      ]))
}
}

})